export const tabs = [
  { title: 'Общая информация', label: 'main' },
  { title: 'Файлы и комментарии', label: 'filesComments' }
]
